import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import debounce from 'lodash/debounce';
import ApiService from '@/services/apiService';
var itemTypeLoadMore = 'LOADMORE.'; // NOTE: should not go beyond the max-limit defined in the ABAC service
// will not lead to any faulty behaviour, but the calculated output of the load-more button may show incorrect values

var fetchLimit = 100;
var processOptionOpenAll = 'open-all';
var processOptionOffsetZero = 'offset-zero';
export default {
  name: 'CoreTenantScopeTree',
  props: {
    userId: {
      type: String,
      required: false,
      default: ''
    },
    subject: {
      type: String,
      required: false,
      default: 'UserManagement'
    },
    action: {
      type: String,
      required: false,
      default: 'manage'
    },
    activeScopeId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      itemTypeLoadMore: itemTypeLoadMore,
      scopeTree: [],
      fetchError: null,
      isLoading: false,
      searchItem: '',
      // to detect if the search-item is deleted and the default should be restored,
      // or to avoid firing the same query twice, store the last queried item here
      lastQueriedSearchItem: null,
      openItems: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'color'])), {}, {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    hasActiveSearch: function hasActiveSearch() {
      return (this.searchItem || '').trim().length >= 2;
    }
  }),
  watch: {
    activeScopeId: function activeScopeId() {
      this.scopeTree = [];

      if (!this.searchItem.trim() && this.activeScopeId) {
        this.fetchSearchResult();
      } else {
        this.fetchChildren({});
      }
    },
    searchItem: debounce(function () {
      // a prior active search-item got deleted, so fetch the default tree again
      if (this.lastQueriedSearchItem && (this.searchItem || '').trim().length < 2) {
        this.lastQueriedSearchItem = null; // make sure to reset the scope-tree here, reset any "open item" states

        this.scopeTree = [];
        this.openItems = [];
        this.fetchChildren({});
        return;
      }

      if ((this.searchItem || '').trim().length >= 2) {
        this.fetchSearchResult();
      }
    }, 500)
  },
  mounted: function mounted() {
    if (!this.searchItem.trim() && this.activeScopeId) {
      this.fetchSearchResult();
    } else {
      this.fetchChildren({});
    }
  },
  methods: {
    processFetchedScopes: function processFetchedScopes(scopeList) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      scopeList.forEach(function (scope) {
        if ((options || []).indexOf(processOptionOpenAll) >= 0) {
          _this.openItems.push(scope.id);
        }

        if (!scope.children && scope.childCnt > 0) {
          scope.children = [];
        }

        if ((scope.children || []).length === 0 && !scope.childCnt) {
          delete scope.children;
        }

        if (scope.children) {
          // remove all existing "load-more" button items
          scope.children = scope.children.filter(function (c) {
            return _this.itemType(c) !== itemTypeLoadMore;
          });

          _this.processFetchedScopes(scope.children, options); // if children had been loaded already, but there are more in total, add a Load-More button at the end of the list
          // contains a reference to its parent, and the offset from which to start loading


          if (scope.childCnt !== undefined && scope.children.length > 0 && scope.children.length < scope.childCnt) {
            // use a zero offset if there is search is active, as all the trees are partial
            var shouldUseZeroOffset = (options || []).indexOf(processOptionOffsetZero) >= 0 || _this.hasActiveSearch && scope.children.length < fetchLimit;
            var totalCount = scope.childCnt;
            var fetchedOffset = scope.children.length;
            var fetchedUpTo = fetchedOffset + fetchLimit; // do not show "Load 101 to 1337 of 503", do not go beyond the total count

            var upperLimit = Math.min(fetchedUpTo, totalCount);
            scope.children.push({
              id: "".concat(itemTypeLoadMore).concat(scope.id),
              name: _this.$i18n_t('DigitalTwin.DigitalTwin.loadMoreItems', {
                nextLower: fetchedOffset + 1,
                nextUpper: upperLimit,
                total: totalCount
              }),
              offset: shouldUseZeroOffset ? 0 : scope.children.length,
              ref: scope
            });
          }
        }
      });
    },
    // findParentInTree(parentId, scopeList) {
    //   let foundParent = scopeList.find((s) => s.id === parentId);
    //   if (foundParent) {
    //     return foundParent;
    //   }
    //   for (let i = 0; i < scopeList.length; i++) {
    //     if ((scopeList[i].children || []).length) {
    //       foundParent = this.findParentInTree(parentId, scopeList[i].children);
    //       if (foundParent) {
    //         return foundParent;
    //       }
    //     }
    //   }
    //   return null;
    // },
    fetchChildren: function () {
      var _fetchChildren = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(item) {
        var _this2 = this;

        var loadingId, offset, refScope;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loadingId = item.id;
                offset = 0;
                refScope = item;

                if (this.itemType(item) === itemTypeLoadMore) {
                  loadingId = item.ref.id;
                  offset = item.offset;
                  refScope = item.ref;
                }

                this.isLoading = true;
                _context.next = 7;
                return ApiService.userScopesFetchChildren(this.userId, this.subject, this.action, loadingId, offset, fetchLimit).then(function (response) {
                  _this2.fetchError = response.error;

                  _this2.processFetchedScopes(response.scopes);

                  if (!loadingId) {
                    _this2.scopeTree = response.scopes; // always open root-items if re-fetching

                    _this2.openItems = response.scopes.map(function (s) {
                      return s.id;
                    });
                  } else {
                    var _refScope$children;

                    if (offset === 0) {
                      // reset the existing children
                      refScope.children = [];
                    }

                    (_refScope$children = refScope.children).push.apply(_refScope$children, _toConsumableArray(response.scopes));
                  }

                  if (refScope) {
                    refScope.childCnt = Math.max(refScope.childCnt, response.totalCount);
                  }

                  _this2.processFetchedScopes(_this2.scopeTree);

                  _this2.isLoading = false;
                }).catch(function (err) {
                  console.error('Could not fetch scope children', loadingId, err);
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchChildren(_x) {
        return _fetchChildren.apply(this, arguments);
      }

      return fetchChildren;
    }(),
    fetchSearchResult: function fetchSearchResult() {
      var _this3 = this;

      this.isLoading = true;
      this.lastQueriedSearchItem = this.searchItem.trim();
      ApiService.userScopesFetchSearchResult(this.userId, this.subject, this.action, this.lastQueriedSearchItem, ['no-children'], // if no search-item was specified, try to load the hierarchy for the active scope
      !this.lastQueriedSearchItem && this.activeScopeId ? this.activeScopeId : undefined).then(function (response) {
        _this3.openItems = [];
        _this3.fetchError = response.error; // open all items to the leaves (where the actual search-results are)
        // as well as set all "Load more" buttons to start loading from offset zero
        // since we do not know where in the actual list the found results are, just load from the start

        _this3.processFetchedScopes(response.scopes, [processOptionOpenAll, processOptionOffsetZero]);

        _this3.scopeTree = response.scopes;
        _this3.isLoading = false;
      }).catch(function (err) {
        console.error('Could not query scope-search', _this3.lastQueriedSearchItem, err);
      });
    },
    selectedScope: function () {
      var _selectedScope = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(item) {
        var tenantName;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                tenantName = undefined; // fetch account-info for this scope

                _context2.next = 3;
                return ApiService.tenantGetById(item.tenant, ['no-descendents', 'bare']).then(function (res) {
                  tenantName = res.name;
                }).catch(function (err) {
                  console.error('Could not get tenant', item, err);
                });

              case 3:
                // emit the selected scope, but without any children (do not propagate a whole tree unnecessarily)
                this.$emit('update', _objectSpread(_objectSpread({}, item), {}, {
                  tenantName: tenantName,
                  children: undefined
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function selectedScope(_x2) {
        return _selectedScope.apply(this, arguments);
      }

      return selectedScope;
    }(),
    itemType: function itemType(item) {
      if ("".concat(item.id).startsWith(itemTypeLoadMore)) {
        return itemTypeLoadMore;
      }

      return null;
    },
    getScopeTreeIcon: function getScopeTreeIcon(scope) {
      var faIcon = "fa-".concat(scope.id === scope.tenantScope ? 'user-friends' : 'key');
      return !scope.parent ? "fas ".concat(faIcon) : "fal ".concat(faIcon);
    },
    itemLabelClass: function itemLabelClass(item) {
      var activeColor = this.color;
      var baseClass = 'selectable-label ';

      if (item.properties && item.properties.disabled) {
        activeColor = 'disabled-twin primary';
        baseClass += 'disabled-twin ';
      }

      return baseClass + (this.activeScopeId === item.id ? "".concat(activeColor, "--text text-bold") : '');
    }
  }
};